// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VPickerTitle = createSimpleFunctional('v-picker-title');
//# sourceMappingURL=VPickerTitle.js.map